class ReviewsYotpoAdapter {
  constructor(source_review) {
    this.source = "Yotpo";
    this.source_review = source_review;

    this.id = this.reviewId();
    this.customer_name = this.customerName();
    this.title = this.title();
    this.content = this.content();
    this.customer_avatar = this.customerAvatar();
    this.customer_title = this.customerTitle();
    this.brand_logo = this.brandLogo();
    this.date = this.reviewDate();
    this.options = this.options();
    this.rating = this.rating();
    this.product_id = this.productId();
    this.product_total_reviews = this.productTotalReviews();
  }

  reviewId() {
    return this.source_review?.id;
  }

  customerName() {
    return this.source_review?.user?.display_name;
  }

  title() {
    return this.source_review?.title;
  }

  content() {
    return this.source_review?.content;
  }

  customerAvatar() {
    return this.source_review?.user?.social_image;
  }

  customerTitle() {
    return undefined;
  }

  brandLogo() {
    return undefined;
  }

  reviewDate() {
    return this.source_review?.created_at;
  }

  options() {
    return {};
  }

  productId() {
    return this.source_review?.product_id;
  }

  rating() {
    let rating = 5;

    if (this.source_review?.score > 0) {
      rating = this.source_review?.score;
    } else if (this.source_review?.average_score > 0) {
      rating = this.source_review?.average_score
    }

    return rating;
  }

  productTotalReviews() {
    if (this.source_review?.total_review === 0) return undefined;

    return this.source_review?.total_review;
  }
}

if (typeof window !== 'undefined' && typeof window.convertflow == 'undefined') {
  window.ReviewsYotpoAdapter = ReviewsYotpoAdapter;
}
